import styles from "../dashboard/dashboard.module.scss";
import Button from "../../components/button/Button";

import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import { Helmet } from "react-helmet";
import React, { useEffect, useState } from "react";
import licenses from "./licenses";
import { FiChevronDown, FiChevronUp, FiZoomIn, FiZoomOut, FiRotateCcw } from "react-icons/fi";
import Workflow from "../../assets/images/Workflow.png";

const About = () => {

  const [licenseList, setLicenseList] = useState([]);
  const [activeSection, setActiveSection] = useState("workflow");
  const [zoomLevel, setZoomLevel] = useState(50);

  const handleZoomIn = () => {
    setZoomLevel((prev) => Math.min(prev + 10, 150)); // Max 150%
  };

  const handleZoomOut = () => {
    setZoomLevel((prev) => Math.max(prev - 10, 20)); // Min 20%
  };

  const handleResetZoom = () => {
    setZoomLevel(50); // Reset to default 50%
  };

  useEffect(() => {
    const dependenciesList = Object.entries(licenses.dependencies).map(
      ([name, details]) => ({
        name,
        version: details.version,
        resolved: details.resolved,
      })
    );
    setLicenseList(dependenciesList);
  }, []);

  return (
    <div className={styles.body}>
      <Helmet>
        <title>Shared Data Portal | Licenses</title>
      </Helmet>
      <div className={styles.pageNameContainer}>
        <div className={styles.pageName}>About</div>
        <Breadcrumbs />
      </div>
      <div className={styles.list}>
        <div
          className={styles.toggleHeader}
          onClick={() =>
            setActiveSection(activeSection === "workflow" ? null : "workflow")
          }
        >
        <div className={styles.headerContent}>
          <span className={styles.title}>Workflow</span>
          {activeSection === "workflow" ? <FiChevronUp /> : <FiChevronDown />}
        </div>
      </div>

        <div
          className={styles.toggleHeader}
          onClick={() =>
            setActiveSection(activeSection === "licenses" ? null : "licenses")
          }
        >
        <div className={styles.headerContent}>
          <span className={styles.title}>Licenses</span>
          {activeSection === "licenses" ? <FiChevronUp /> : <FiChevronDown />}
        </div>
      </div>
        {activeSection === "workflow" && (
          <div className={styles.list}>
            {/* Zoom Controls */}
            <div className={styles.zoomControls}>
              <button
                onClick={handleZoomOut}
                disabled={zoomLevel <= 20}
                className={styles.zoomButton}
                title="Zoom Out"
              >
                <FiZoomOut size={18} />
              </button>
              <span className={styles.zoomLevel}>
                {zoomLevel}%
              </span>
              <button
                onClick={handleZoomIn}
                disabled={zoomLevel >= 150}
                className={styles.zoomButton}
                title="Zoom In"
              >
                <FiZoomIn size={18} />
              </button>
              <button
                onClick={handleResetZoom}
                className={`${styles.zoomButton} ${styles.resetButton}`}
                title="Reset Zoom"
              >
                <FiRotateCcw size={18} />
              </button>
            </div>

            {/* Image Container with Scroll */}
            <div className={styles.imageContainer}>
              <img
                src={Workflow}
                alt="Workflow Diagram"
                className={styles.workflowImage}
                style={{ width: `${zoomLevel}%` }}
              />
            </div>
          </div>
        )}

      </div>
      {activeSection === "licenses" && (
        <div className={styles.list}>
          {/* <p><strong>License</strong></p> */}
        <p>Below is a list of direct dependencies used in this project and their licenses:</p>
        <ul style={{margin: "10px"}}>
          {licenseList.map((dependency) => (
            <li key={dependency.name}>
              <strong>{dependency.name}</strong> (version {dependency.version})<br />
              <a href={dependency.resolved} target="_blank" rel="noopener noreferrer">
                {dependency.resolved}
              </a>
            </li>
          ))}
        </ul>


      </div>
      )}
    </div>
  )
}

export default About;